export default __webpack_public_path__ + "static/summer_containers63-c8769885f695be32a48b9c991ca8404b.webp";